import React from 'react'
import { Banner } from '../../../../components'
import { THEMES } from '../../../../utils'

/**
 * Contact Detail Banner Component
 * @param props
 * @returns {*}
 * @constructor
 */
const ContactDetailBanner = (props) => {
  const {
    contact: { initialLoading, salutation, fullName, status }, onContactEdit
  } = props

  return (
    <Banner
      title={[]
        .concat(salutation, fullName)
        .filter((name) => name && name.trim()).join(' ')}
      icon='q4i-contact-2pt'
      controls={[
        {
          label: 'Edit',
          theme: THEMES.CITRUS,
          hidden: initialLoading || (status && status === 'gdpr'),
          onClick: onContactEdit
        }
      ]} />
  )
}

export default ContactDetailBanner
